var waitForJQuery = setInterval(function () {
	if (typeof $ != 'undefined') {
		console.log('loaded jquery')
		// place your code here.
		clearInterval(waitForJQuery);
		initApp();
	} else {
		console.log('waiting for jquery')
	}
}, 500);

function initUpsellEvents() {
	$('.js-cart-upsell-add').on('click', function(e){
		var id = $(this).data('variant-id');
		
		jQuery.ajax({
			url: '/cart/add.js',
			dataType: 'json',
			type: 'post',
			data: {
				quantity: 1,
				id: id
			},
			beforeSend: function() {
				$('.cart__form').addClass('processing');
			},
			success: function (response) {
				var node = "<div id='item-" + response.id + "' " +
						"class='cart-item' " +
						"data-id='" + response.key +"' " +
						"data-qty='" + response.quantity + "' " +
						"data-title='" + response.title + "'>" +
						"<a href='" + response.url + "' class='thumbnail'>" +
						"<figure class='lazy-image' data-ratio style='padding-top:120%'>" +
						"<img class='lazyautosizes ls-is-cached lazyloaded' src='" + response.image + "'>" +
						"</figure></a>" +
						"<div class='content'>" +
						"<a href='" + response.url + "' class='title'>" + response.title + "</a>" +
						"<div class='price'><span class='money'>" + Shopify.formatMoney(response.price) + "</span></div>" +
						"</div>" +
						"<div class='actions'>" +
						"<input class='qty' min='0' type='number' name='updates[]' id='updates_" + response.id + "' value='" + response.quantity +"'>" +
						"<a class=\"remove\" title=\"Remove item from cart\" aria-label=\"Remove item from cart\"><span aria-hidden=\"true\"><svg version=\"1.1\" class=\"svg close\" xmlns=\"//www.w3.org/2000/svg\" xmlns:xlink=\"//www.w3.org  /1999/xlink\" x=\"0px\" y=\"0px\" width=\"60px\" height=\"60px\" viewBox=\"0 0 60 60\" enable-background=\"new 0 0 60 60\" xml:space=\"preserve\"><polygon points=\"38.936,23.561 36.814,21.439 30.562,27.691 24.311,21.439 22.189,23.561 28.441,29.812 22.189,36.064 24.311,38.186 30.562,31.934 36.814,38.186 38.936,36.064 32.684,29.812 \"></polygon></svg></span></a>" +
						"</div>" +
						"</div>";
				
				$('.cart__items').append(node);
				$('.cart__form').removeClass('processing');
				
				window.cartFormAjax();
				
				// update totals
				jQuery.ajax({
					url: '/cart',
					dataType: 'json',
					type: 'get',
					success: function(cart) {
						var totalPrice = Shopify.formatMoney(cart.total_price);
						$('#CartTotal').find('.money').html(totalPrice);
					}
				})
			}
		});
	})
}

function initCartEvents() {
  $('#cart').on('click', '.js-sidebar-close', function(){
    $('.sidebar__cart-close').trigger('click');
  })
}

function initStoreEvents() {
  //KING.Sidebar.mount();

  if ($(window).width() < 960) {
    $(".sidebar__menu-handle, .sidebar__menus-close").on("click", (function(e) {
      e.preventDefault(),
      $(".sidebar__menus").removeClass("kill-overflow"),
      $(".sidebar__menus").hasClass("opened") ? ($(".sidebar__menus").removeClass("opened"),
      $(".cart-overlay-background").removeClass("show"),
      $("body").removeClass("overflow-hidden")) : ($(".sidebar__menus").addClass("opened"),
      $(".cart-overlay-background").addClass("show"),
      $("body").addClass("overflow-hidden"))
  }
  ))

  $(".sidebar__cart-handle, .sidebar__cart-close").on("click", (function(e) {
    e.preventDefault();
    $(".sidebar__cart, .sidebar__cart .cart").css("height", window.innerHeight)
    if ($(".sidebar__cart").hasClass("opened")) {
      $(".sidebar__cart").removeClass("opened"),
      $(".cart-overlay-background").removeClass("show"),
      $("body").removeClass("overflow-hidden");
    } else {
      $(".sidebar__cart").addClass("opened"),
      $(".cart-overlay-background").addClass("show"),
      $("body").addClass("overflow-hidden");
      var s = -1 * r[0].getBoundingClientRect().y;
      $(".sidebar__cart").css("transform", "translateY(" + s + "px)")
    }   
  }))
  
  $(".sidebar__search-handle, .sidebar__search-close").on("click", (function(e) {
    e.preventDefault();

    if ($(".sidebar__search").hasClass("opened")) {
      $(".sidebar__search").removeClass("opened")
    } else {
      $(".sidebar__search").addClass("opened")
    }

    $('.sidebar__search input[type="search"]').attr("placeholder", $('.sidebar__search input[type="search"]').data("responsive-placeholder"))

    setTimeout((function() {
        $('.sidebar__search input[type="search"]')[0].focus()
    }), 100)
  }));
  }
  
}

function initPdpSelectSizeWarning() {
  $('#addToCartBtn').on('click touchend', function(){
    var isDisabled = $(this).find('button').attr('disabled'),
        $msg = $('#selectSizeMsg');
    
    if (isDisabled) {
      $msg.removeClass('hidden');
      scrollPage('#addToCartBtn', 1000);
    } else {
      $msg.addClass('hidden');
    }
  })
}

function scrollPage(el, timing, correction) {
    var scrollTime = timing || 1000,
        correctionBuffer = $('.sidebar').height() + 300,
        scrollPosition = $(el).offset().top - correctionBuffer;

    window.scrollTo({
      top: scrollPosition,
      left: 0,
      behavior: "smooth",
    });
}

function checkInViewport($el) {
    var elementTop = $el.offset().top;
    var elementBottom = elementTop + $el.outerHeight();
    
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    
    return elementBottom > viewportTop && elementTop < viewportBottom;
}

function initializePdpScroll() {
    var $button = $('#addToCartBtn .product__add-to-cart'),
        $language = $('.ly-switcher-wrapper');
    
    $(window).on('resize scroll', function() {
        if (checkInViewport($('#addToCartBtn'))) {
            $button.removeClass('is-fixed');
            $language.removeClass('is-relative');
        } else {
            if (!$button.hasClass('is-fixed')) {
                $button.addClass('is-fixed');
                $language.addClass('is-relative');
            }
        }
    });
}

function initBuyNowReplacement() {
  $(".shopify-payment-button").detach().insertAfter('.product__quantity-submit').addClass('is-active')
}

function initApp() {
  $('document').ready(function () {
    initUpsellEvents();
    initCartEvents();
    initStoreEvents();
    initPdpSelectSizeWarning();
    initializePdpScroll();
    initBuyNowReplacement();
  })
}

